import React from 'react';
import styled from 'styled-components';

type SocialChannel = {
	label: string;
	url: string;
};

interface Props {
	items: Record<string, SocialChannel>;
}

const Container = styled.div`
	display: grid;
	grid-gap: 16px;
	grid-auto-flow: column;
	justify-content: center;
`;

const SocialMediaButton = styled.a<{ $name: string; }>`
	${({ $name, theme }) => theme.iconButton({ icon: { name: $name, color: '#cecece' } })};
`;

export const SocialChannels = ({ items }: Props) => {

	return <Container>
		{Object.entries(items).map(([channelId, { label, url }]) =>
			<SocialMediaButton key={channelId} $name={channelId} href={url}>{label}</SocialMediaButton>)
		}
	</Container>
};